import React, { useReducer, useEffect, useState } from "react"
import { getCountryCallingCode } from "react-phone-number-input"
import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.svg"
import feature3 from "./feature-3.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import SEO from "../../../components/seo"
import { requestService } from "../../../services"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const CounterfeitX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const data = {
    title: "Don’t let fake sellers \nerode your brand \ncredibility",
    bannerImage: banner,
    desc:
      "The intelligent brand protection tool will prevent malicious \nattempts to sell fake products under \nyour brand name.",
    overview: "CounterfeitX Overview",
    overviewText:
      "Studies have shown that 1 in every 5 products is a fake. Wersel’s CounterfeitX solution helps you to combat this problem the smart way to protect brand reputation and your business toplines. Improve your brand’s sale scope with the assurance that your customers see only authentic product and not buy fake products sold under your brand name, The AI-based solution is powered by deep learning and machine learning algorithms that help sift out the fake from the legit products and bring you all the data needed to take corrective action against a breach of brand trust and customer loyalty. Utilize this proprietary tool and prevent the menace of fake products sold by unauthorized resellers and rogue retailers. This makes CounterfeitX the only solution you need to emerge victorious in the battle of legit vs. fakes. It is the ultimate brand protection tool you simply can’t afford to miss out on.",
    features: [
      {
        title: "Monitor",
        description:
          "It monitors auction sites and eCommerce sites for counterfeit products. \nConstant monitoring \nenables quick alerts and nips damage in the bud.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "Social media",
        description:
          "Worried about fake products being sold on social media? Then we can help. \nIt monitors social media posts/messages leading to rogue eCommerce \nsites and infringing auction sites.",
        featureImage: feature2,
        imagePosition: "left",
      },
      {
        title: "Ultimate brand \nprotection",
        description:
          "It monitors auction sites and eCommerce sites for counterfeit products. \nConstant monitoring enables quick alerts and nips damage in the bud.",
        featureImage: feature3,
        imagePosition: "right",
      },
    ],
    subSectionTitle: "Explore CounterfeitX",
    platformText:
      "Customers no longer need to be deceived with fake products delivered to them. With CounterfeitX you can prevent erosion of brand value and customer loyalty as they get their hands on only legit products under your brand name.",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "counterfeitx",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#E51B20" btnColor="#FFFFFF">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel CounterfeitX – the only AI tool you need protect your brand credibility"
        keywords="anti counterfeit solution, counterfeit solution, anti counterfeit software, counterfiet software"
        description="Don’t let fake sellers erode your brand credibility. Get a radical mechanism to prevent the counterfeit menace"
        url="www.wersel.io/products/counterfeitx"
      />
      <OurSolutions data={data} btnBg="#E51B20" btnColor="#FFFFFF" />
      <Features title="CounterfeitX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="Get a radical mechanism to prevent the counterfeit menace"
        howItWorks="CounterfeitX – the only AI tool you need protect your brand credibility"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#E51B20"
        btnColor="#FFFFFF"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default CounterfeitX
